export default __webpack_public_path__ + "ca4709dbe7c8cbc022a0a73d95b6370a.svg";